<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg
      v-if="exceptionMsg"
      :msg="exceptionMsg"
      :image="exceptionImg"
    />

    <div
      v-if="
        grantsConstraintsPlans.grantsConstraintsPlansData != undefined &&
        grantsConstraintsPlans.grantsConstraintsPlansData.length != 0
      "
    >
      <GrantsConstraintsPlansTable
        v-on:setGrantsConstraintsPlan="
          grantsConstraintsPlans.grantsConstraintsPlan.fillData($event)
        "
        :grantsConstraintsPlansData="
          grantsConstraintsPlans.grantsConstraintsPlansData
        "
        :pagination="grantsConstraintsPlans.pagination"
      />

      <Pagination
        v-if="!isLoading"
        :paginationData="grantsConstraintsPlans.pagination"
        v-on:changePage="changePage"
      />
      <GrantsConstraintsPlanInfo
        :grantsConstraintsPlan="grantsConstraintsPlans.grantsConstraintsPlan"
      />
      <GrantsConstraintsPlanDelete
        :grantsConstraintsPlan="grantsConstraintsPlans.grantsConstraintsPlan"
        v-on:refresh="getGrantsConstraintsPlanses()"
      />
    </div>

    <GrantsConstraintsPlanBtns
      :theFilterData="grantsConstraintsPlans.filterData"
      v-on:search="search($event)"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import GrantsConstraintsPlansTable from "@/components/settings/settingsSalary/grantsConstraintsPlans/GrantsConstraintsPlansTable.vue";
import GrantsConstraintsPlanInfo from "@/components/settings/settingsSalary/grantsConstraintsPlans/GrantsConstraintsPlanInfo.vue";
import GrantsConstraintsPlanDelete from "@/components/settings/settingsSalary/grantsConstraintsPlans/GrantsConstraintsPlanDelete.vue";
import GrantsConstraintsPlanBtns from "@/components/settings/settingsSalary/grantsConstraintsPlans/GrantsConstraintsPlanBtns.vue";
import Pagination from "@/components/general/Pagination.vue";
import GrantsConstraintsPlans from "@/models/settings/settingsSalary/grantsConstraintsPlans/GrantsConstraintsPlans";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    GrantsConstraintsPlansTable,
    GrantsConstraintsPlanInfo,
    GrantsConstraintsPlanDelete,
    GrantsConstraintsPlanBtns,
    Pagination,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken,
      language: localStorage.getItem("userLanguage") || "ar",
      grantsConstraintsPlans: new GrantsConstraintsPlans(),
    };
  },
  methods: {
    changePage(page) {
      this.grantsConstraintsPlans.pagination.selfPage = page;
      this.getGrantsConstraintsPlanses();
    },
    search(data) {
      this.grantsConstraintsPlans.filterData.fillData(data);
      this.grantsConstraintsPlans.grantsConstraintsPlansData = [];
      this.getGrantsConstraintsPlanses();
    },
    async getGrantsConstraintsPlanses() {
      this.isLoading = true;
      try {
        const response =
          await this.grantsConstraintsPlans.grantsConstraintsPlan.getGrantsConstraintsPlanses(
            this.language,
            this.userAuthorizeToken,
            this.grantsConstraintsPlans.pagination,
            this.grantsConstraintsPlans.filterData
          );

        if (response.data.status == STATUS.SUCCESS) {
          this.exceptionMsg = null;
          this.grantsConstraintsPlans.fillData(response.data);
        } else if (response.data.status == STATUS.NO_CONTENT) {
          this.grantsConstraintsPlans.grantsConstraintsPlansData = [];
          this.exceptionImg = "";
          this.exceptionMsg = response.data.msg;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.grantsConstraintsPlans.grantsConstraintsPlansData = [];
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.grantsConstraintsPlans.grantsConstraintsPlansData = [];
          this.exceptionImg = "";
          this.exceptionMsg = response.data.msg;
        }
      } catch (error) {
        this.grantsConstraintsPlans.grantsConstraintsPlansData = [];
        this.exceptionImg = "illustrator-somethingWrong.svg";
        this.exceptionMsg = this.$t("errorCatch");
      }
      this.isLoading = false;
    },
  },
  computed: {},
  async created() {
    this.getGrantsConstraintsPlanses();
  },
};
</script>
